import React from 'react'
import * as Sentry from '@sentry/react'
import { ErrorBoundary } from 'react-error-boundary'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

import loadable from '@loadable/component'

import { ContextProps } from './types/types'
import AppProvider from './utils/appProvider'

const LoadableAppLayout = loadable(() => import('./AppLayout'))

export interface IEntryPointProps extends ContextProps {
	fragmentType: string
}

const Entrypoint: React.FC<React.PropsWithChildren<IEntryPointProps>> = (props) => {
	switch (props.fragmentType) {
		case 'appLayout':
		default:
			return (
				<ErrorBoundary
					onError={(error) => {
						Sentry.captureException(error)
					}}
					FallbackComponent={() => <HttpStatus status={500}>{null}</HttpStatus>}
				>
					<AppProvider {...props}>
						<LoadableAppLayout {...props} />
					</AppProvider>
				</ErrorBoundary>
			)
	}
}

export default Entrypoint
